<template>
  <div>
    <div class="text-red-600">
      * ตารางการคำนวณดังกล่าว เป็นการคำนวณคร่าวๆ ยอดเงินต้นและดอกเบี้ยอาจเปลี่ยนแปลงตามวันที่ชำระ
    </div>
    <div class="flex flex-col gap-4 bg-white p-4 rounded-2xl shadow mb-5">
      <!-- ค่าดำเนินคดี  & อากร-->
      <div class="flex gap-4">
        <div class="flex items-center gap-2 w-1/2">
          <label class="block text-gray-700 mb-0 w-1/2">ค่าดำเนินคดี</label>
          <vs-input type="number" class="input w-1/2" v-model="totalProsecutionFee" disabled="disabled"/>
        </div>
        <div class="flex items-center gap-2 w-1/2">
          <label class="block text-gray-700 mb-1 w-1/2">อากร</label>
          <vs-input type="number" class="input w-1/2" v-model="form.taxAmount"/>
        </div>
      </div>

      <!-- ค่าธรรมเนียมยกมา-->
      <div class="flex gap-4">
        <div class="flex items-center gap-2 w-1/2">
          <label class="block text-gray-700 mb-0 w-1/2">ค่าธรรมเนียมยกมา | ชำระ | คงเหลือ</label>
          <div class="flex gap-2 w-1/2">
            <vs-input type="number" class="input w-full" v-model="form.restructuringFee"/>
          </div>
        </div>
        <div class="flex items-center gap-2 w-1/2">
          <div class="flex gap-2 w-1/2">
            <vs-input type="number" class="input w-full" v-model="summary.fee" disabled="disabled"/>
          </div>
          <div class="flex gap-2 w-1/2">
            <vs-input type="number" class="input w-full" v-model="summary.feeRemaining" disabled="disabled"/>
          </div>
        </div>
      </div>

      <!-- เบี้ยปรับยกมา-->
      <div class="flex gap-4">
        <div class="flex items-center gap-2 w-1/2">
          <label class="block text-gray-700 mb-0 w-1/2">เบี้ยปรับยกมา | ชำระ | คงเหลือ</label>
          <div class="flex gap-2 w-1/2">
            <vs-input type="number" class="input w-full" v-model="form.restructuringPenalty"/>
          </div>
        </div>
        <div class="flex items-center gap-2 w-1/2">
          <div class="flex gap-2 w-1/2">
            <vs-input type="number" class="input w-full" v-model="summary.penalty" disabled="disabled"/>
          </div>
          <div class="flex gap-2 w-1/2">
            <vs-input type="number" class="input w-full" v-model="summary.penaltyRemaining" disabled="disabled"/>
          </div>
        </div>
      </div>

      <!-- ดอกเบี้ย -->
      <div class="flex gap-4">
        <div class="flex items-center gap-2 w-1/2">
          <label class="block text-gray-700 mb-0 w-1/2">ดอกเบี้ยยกมา | ชำระ | คงเหลือ</label>
          <div class="flex gap-2 w-1/2">
            <vs-input type="number" class="input w-full" v-model="totalRestructuringInterest" disabled="disabled"/>
          </div>
        </div>
        <div class="flex items-center gap-2 w-1/2">
          <div class="flex gap-2 w-1/2">
            <vs-input type="number" class="input w-full" v-model="summary.interest" disabled="disabled"/>
          </div>
          <div class="flex gap-2 w-1/2">
            <vs-input type="number" class="input w-full" v-model="summary.interestRemaining" disabled="disabled"/>
          </div>
        </div>
      </div>

      <!-- รวมยอดยกมาคงเหลือ -->
      <div class="flex gap-4">
        <div class="flex items-center gap-2 w-1/2">
          <label class="block text-gray-700 mb-1 w-1/2">รวมยอดยกมาคงเหลือ <small class="text-grey">(ไม่คิดดอกเบี้ยเพิ่มเติม)</small></label>
          <vs-input type="number" class="input w-1/2" :value="totalRestructuring" disabled="disabled"/>
        </div>
        <div class="flex items-center gap-2 w-1/2"></div>
      </div>

      <!-- เงินต้น -->
      <div class="flex gap-4">
        <div class="flex items-center gap-2 w-1/2">
          <label class="block text-gray-700 mb-0 w-1/2">เงินต้น | ชำระ | คงเหลือ</label>
          <div class="flex gap-2 w-1/2">
            <vs-input type="number" class="input w-full" v-model="form.principle"/>
          </div>
        </div>
        <div class="flex items-center gap-2 w-1/2">
          <div class="flex gap-2 w-1/2">
            <vs-input type="number" class="input w-full" v-model="summary.principal" disabled="disabled"/>
          </div>
          <div class="flex gap-2 w-1/2">
            <vs-input type="number" class="input w-full" v-model="summary.principalRemaining" disabled="disabled"/>
          </div>
        </div>
      </div>

      <!--      <hr>-->
      <vs-divider/>

      <!-- จำนวนงวด & อัตราดอกเบี้ย -->
      <div class="flex gap-4">
        <div class="flex items-center gap-2 w-1/2">
          <label class="block text-gray-700 mb-1 w-1/2">
            จำนวนงวด
            <small class="text-grey">(เฉพาะงวดที่เริ่มชำระเงินต้น)</small>
          </label>
          <vs-input type="number" class="input w-1/2" v-model="form.installmentCount"/>
        </div>
        <div class="flex items-center gap-2 w-1/2">
          <label class="block text-gray-700 mb-0 w-1/2">
            อัตราดอกเบี้ย %
            <small class="text-grey">(คิดเฉพาะเงินต้น)</small>
          </label>
          <vs-input type="number" class="input w-1/2" v-model="form.interestRate"/>
        </div>
      </div>

      <div class="flex gap-4">
        <div class="flex items-center gap-2 w-1/2">
          <label class="block text-gray-700 mb-1 w-1/2">
            รอบชำระเดือนแรก
            <small class="text-grey">(กำหนดวันที่สิ้นเดือน)</small>
          </label>
          <flat-pickr :config="form.configPaymentDue" class="input w-1/2" v-model="form.paymentDue"/>
        </div>
        <div class="flex items-center gap-2 w-1/2"></div>
      </div>

      <div class="flex justify-end">
        <vs-button color="primary"
                   @click="$emit('calculate', { restructuringAmount: totalRestructuring, principalAmount: summary.principalRemaining})">
          คำนวณ
        </vs-button>
      </div>
    </div>
  </div>
</template>

<script>
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/themes/dark.css'
import {round} from "lodash";
import DividerDefault from "@/views/components/vuesax/divider/DividerDefault.vue";

/**
 * @typedef {Object} ProsecutionFeeForm
 * @property {number} lawyerFee ค่าทนาย
 * @property {number} reminderLetterFee ค่าหนังสือทวงถาม
 * @property {number} courtFee ค่าธรรมเนียมศาล
 * @property {number} summonFee ค่าส่งคำคู่ความ
 * @property {number} documentFee ค่าจัดทำเอกสาร
 * @property {number} enforceFee ค่าส่งคำบังคับ
 * @property {number} litigationFee ค่าดำเนินคดี
 */

/**
 * @typedef {Object} RestructuringInterestForm
 * @property {number} interestAsPerLawsuit ดอกเบี้ยตามฟ้อง
 * @property {number} interestUntilLawsuitDate ดอกเบี้ยคิดถึงวันฟ้อง
 * @property {number} interestAfterLawsuitDate ดอกเบี้ยถัดจากวันฟ้อง
 */

/**
 * @typedef {Object} LoanForm
 * @property {number} restructuringFee
 * @property {number} restructuringPenalty
 * @property {ProsecutionFeeForm} prosecutionFee
 * @property {RestructuringInterestForm} restructuringInterest
 * @property {number} principle
 * @property {number} installmentCount
 * @property {number} interestRate
 * @property {string} paymentDue
 * @property {Object} configPaymentDue
 */

export default {
  name: 'LoanInputSection',
  components: {DividerDefault, flatPickr},
  props: {
    /** @type {LoanForm} */
    form: {type: Object, required: true}
  },
  computed: {
    totalProsecutionFee() {
      const pf = this.form.prosecutionFee
      return [
        pf.lawyerFee,
        pf.reminderLetterFee,
        pf.courtFee,
        pf.summonFee,
        pf.documentFee,
        pf.enforceFee,
        pf.litigationFee
      ].reduce((sum, val) => sum + Number(val || 0), 0)
    },
    totalRestructuringInterest() {
      const ri = this.form.restructuringInterest
      return [
        ri.interestAsPerLawsuit,
        ri.interestUntilLawsuitDate,
        ri.interestAfterLawsuitDate
      ].reduce((sum, val) => sum + Number(val || 0), 0)
    },
    summary() {
      const result = this.form.payments.reduce((sum, payment) => {
        return {
          fee: sum.fee + Number(payment.fee || 0),
          penalty: sum.penalty + Number(payment.penalty || 0),
          interest: sum.interest + Number(payment.interest || 0),
          principal: sum.principal + Number(payment.principal || 0),
        }
      }, {fee: 0, penalty: 0, interest: 0, principal: 0})

      // แปลงเป็นค่าติดลบทั้งหมด
      const feeRemaining = this.form.restructuringFee - result.fee;
      const penaltyRemaining = this.form.restructuringPenalty - result.penalty;
      const interestRemaining = this.totalRestructuringInterest - result.interest;
      const principalRemaining = this.form.principle - result.principal;
      return {
        fee: round(result.fee * -1, 2),
        feeRemaining: round(feeRemaining, 2),
        penalty: round(result.penalty * -1, 2),
        penaltyRemaining: round(penaltyRemaining, 2),
        interest: round(result.interest * -1, 2),
        interestRemaining: round(interestRemaining, 2),
        principal: round(result.principal * -1, 2),
        principalRemaining: round(principalRemaining, 2),
      }
    },
    totalRestructuring() {
      const total = this.totalProsecutionFee +
        Number(this.form.taxAmount) +
        Number(this.summary.feeRemaining || 0) +
        Number(this.summary.penaltyRemaining || 0) +
        Number(this.summary.interestRemaining || 0)
      return round(total, 2);
    },
  }
}

</script>
